/**
 * Extracted from sections/ns-tabbed-videos.liquid (inline <script> at line 366).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at sections/ns-tabbed-videos.liquid:366) ---
(function () {
let allVideoPlayButtons = document.querySelectorAll(".content-over-media:not(.clicked)");
allVideoPlayButtons.forEach((el)=>{
  el.addEventListener("click",()=>{
if(!el.classList.contains("clicked")){

    console.log('playing video')
    el.closest('.content-over-media')?.querySelector('video')?.play();
    el.closest('.content-over-media')?.querySelector('.poster-video')?.classList.add('hidden')
    el.classList.add("clicked");
}
  })
})
document.querySelectorAll('.content-over-media video').forEach(video => {
  video.addEventListener('click', () => {
    if (video.paused) {
      console.log('playit')
     //video.play();
    } else {
      console.log('pauseit')
     // video.pause();
    }
  });
});
})();
